import * as React from "react"
import {Box} from "@mui/material";

import { SkuInfoBlock } from "@components";
import { BACKEND_APIS } from "@constants";

export default function productSkuColumn() {
	return [{
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'company', label: 'Company',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'line', label: 'Line',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'SKU',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'skuName',
		label: 'Product SKU',
		options: {
			setCellHeaderProps: () => ({ sx: { minWidth: 350 } }),
			filter: false,
			customBodyRowRenderLite: (value, row) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<RenderProductSkuColumn skuName={value} row={row} />
			</Box>
		}
	}]
}

function RenderProductSkuColumn({ skuName, row }) {
	return <SkuInfoBlock
		sku={skuName}
		category={row.category}
		brand={row.brand}
		ean={row.ean}
		reference={row.reference}
	/>
}